/**
 * Include all workflow status types.
 * See {@link https://github.com/gogovan/entier-whizr-backend/blob/trunk/src/modules/orders/domain/enum/workflow-status-type.enum.ts}
 * @typedef {Object} WorkflowStatusType
 */
var WorkflowStatusType = {
  CREATED: 'created',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  ASSIGNED: 'assigned',
  PICKED_UP: 'picked_up',
  DELIVERED: 'delivered',
  EXCEPTION: 'exception',
  USER_DEFINED: 'user_defined'
};

export { WorkflowStatusType };
